import React from "react"
import styled from "styled-components"

const BankAccount = ({ accountNumber, iban, image, accountType, lang }) => {
  const words = {
    ar: {
      name: ":صاحب الحساب",
      address: ":عنوان المصرف",
      number: ":رقم الحساب",
      swift: ":رمز السويفت",
      accountIban: ":رقم الأيبان ",
    },
    en: {
      name: "Account owner:",
      address: "Bank address: ",
      number: "Account No:",
      swift: "Swift Code:",
      accountIban: "IBAN NO: ",
    },
    tr: {
      name: "Hesap sahibi: ",
      address: "Şubenin adresi: ",
      number: "Hesap numarası: ",
      swift: "Suift kodu: ",
      accountIban: "IBAN NO:",
    },
  }
  const { name, address, number, swift, accountIban } = words[lang]
  return (
    <Wraper>
      <img src={image} alt="bankIcon" />
      <h3>{accountType}</h3>
      <p className="accountTitle">{name}</p>
      <p className="information">
        EL RİSELE EĞİTİM VE <br />
        YARDIMLAŞMA DERNEĞİ
      </p>
      <p className="accountTitle">{address}</p>
      <p className="information">
        Cumhuriyet Cad. No :171 <br />
        Kilis / Turkey
      </p>
      <p className="accountTitle">{number}</p>
      <p className="information">{accountNumber}</p>
      <p className="accountTitle">{swift}</p>
      <p className="information">TCZBTR2A</p>
      <p className="accountTitle">{accountIban}</p>
      <p className="information">{iban}</p>
    </Wraper>
  )
}

export default BankAccount
const Wraper = styled.section`
  border: 2px solid ${props => props.theme.borderColor};
  &:hover {
    background: white;
    transition: ${props => props.theme.tr};
  }
  padding: 10px 2px;
  img {
    width: 100px;
  }
  h3 {
    color: ${props => props.theme.lg};
    margin: 10px 0 30px 0;
    font-weight: bold;
    font-size: 2rem;
  }
  .accountTitle {
    color: ${props => props.theme.dg};
    margin-bottom: 5px;
    font-size: 1.6rem;
    font-weight: bolder;
  }
  .information {
    font-size: 1.3rem;
    color: ${props => props.theme.g2};
  }
`
